import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';

import { rikHttpClient } from 'services/httpClient';
import IGetAllThreadsInterventionResponse from 'services/httpClient/responses/intervention/IGetAllThreadsInterventionResponse';

import { interventionActions } from '../index';
import { IGetAllThreadsRequestAction } from '../reducers/getAllThreads/request';

function* getAllThreads(action: PayloadAction<IGetAllThreadsRequestAction>) {
  try {
    const urlParams = new URLSearchParams({
      intervention_id: action.payload.data.interventionId.toString(),
    });

    const { data }: AxiosResponse<IGetAllThreadsInterventionResponse[]> =
      yield call(
        rikHttpClient.get,
        `messages/${action.payload.data.traderId}/threads?${urlParams}`,
      );

    if (!data.length) {
      yield put(
        interventionActions.getAllThreadsSuccessWithoutData({
          message: 'noMessagesFound',
        }),
      );
    }

    yield put(
      interventionActions.getAllThreadsSuccessWithData({
        list: data,
      }),
    );
  } catch (err: any) {
    action.payload.functions.error(err);

    yield put(interventionActions.getAllThreadsFailure());
  }
}

export default getAllThreads;
